import { request, callApi, filterExcludedCurrencies } from 'utils';
import { FETCH_CURRENCY_LIST, FETCH_CURRENCY_RATES } from 'actionTypes';
import { normalize } from 'normalizr';
import {
  convertorCurrencyList as currencyListSchema,
  convertorCurrencyRatesBuySell as buySellSchema,
} from 'schemas';

export const fetchCurrencyList = params => {
  const action = () =>
    request({
      url: `${process.env.APP_CURRENCIES_API_URL}/list`,
      method: 'get',
      params,
    }).then(response => {
      if (response?.list && Array.isArray(response.list)) {
        const filteredList = filterExcludedCurrencies(response.list);
        const { entities: { currencyList: entities = {} } = {} } = normalize(
          filteredList,
          currencyListSchema
        );

        const normalizedList = Object.values(entities);

        return {
          ...response,
          list: normalizedList,
        };
      }
      return response;
    });

  return callApi(action, FETCH_CURRENCY_LIST, {
    params,
  });
};

const normalizeBuySell = buySellData => {
  if (!buySellData) return null;
  const { entities: { currencyRateBuySell: entities = {} } = {} } = normalize(
    buySellData,
    buySellSchema
  );
  const [entity] = Object.values(entities);
  return entity;
};

export const fetchCurrencyRates = params => {
  const action = () =>
    request({
      url: `${process.env.APP_CURRENCIES_API_URL}/data/`,
      method: 'get',
      params,
    }).then(({ data }) => {
      const optimizedData = Object.keys(data).reduce((acc, currencyCode) => {
        acc[currencyCode] = {};
        Object.keys(data[currencyCode]).forEach(rateType => {
          const rateData = data[currencyCode][rateType];
          if (rateData?.buy || rateData?.sell) {
            acc[currencyCode][rateType] = {
              buy: normalizeBuySell(rateData.buy),
              sell: normalizeBuySell(rateData.sell),
            };
          }
        });
        return acc;
      }, {});

      return { data: optimizedData };
    });

  return callApi(action, FETCH_CURRENCY_RATES, {
    params,
  });
};
